import styled from 'styled-components'
import Select from 'react-select'

export const Container = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  & .react-select__control {
    padding: 16px;
    overflow: hidden;
    white-space: nowrap;
  }

  & react-select__input-container {
    overflow: hidden;
  }

  & .react-select__input {
    white-space: nowrap;
    border: 1px;
  }
`

export const CustomSelect = styled(Select)`
  min-width: 100px;
  width: 100%;
`

export const OptionContainer = styled.div`
  text-align: start;
  cursor: pointer !important;
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  background: #fff;
  transition: background 0.2s;

  &[data-active='true'] {
    background: #d7e6ff !important;
  }

  &:hover {
    background: #f7f7f7;
  }

  .title {
    color: #161616;

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
  }

  .description {
    align-self: stretch;
    color: #74788d;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.48px;
  }
`

export const Button = styled.button`
  border: none;
  outline: none;
  background: none;
`

export const SelectedValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;
  overflow: hidden;
  p {
    color: #161616;
    leading-trim: both;
    text-edge: cap;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    white-space: break-spaces;
  }

  span {
    color: #74788d;
    leading-trim: both;
    text-edge: cap;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: break-spaces;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`
